import { View } from "@pimo/pimo-app-builder";
import {
  DragAndDropLayout,
  PMBarChartCard,
  PMDonutChartCard,
} from "@pimo/pimo-components";

import { TestAppState } from "../../../app";
import { DONUT_CARD_LAYOUT } from "../../../constants";
import {
  getAllReportingItems,
  getArrayFieldData,
  withTotalInTitle,
} from "../get-dashboard-chart-data";

/**
 * Adds the "systems per process step" bar and donut chart cards, in that
 * order (#2222).
 */
export function addProcessStepsDashboardCards(
  view: View<TestAppState, DragAndDropLayout>
) {
  const processStepsBarChartComponent = view.addComponent({
    component: PMBarChartCard,
    layoutProps: {
      componentId: "processStepsDashboardBarChartComponent",
      labels: ["barChart", "chart", "processStep"],
      description: "Shows systems grouped by process step across all projects.",
      title: "Systems per Process Step (Bar Chart)",
    },
  });

  processStepsBarChartComponent.mapState(({ dashboard }) => {
    const allItems = getAllReportingItems(dashboard);
    const { entries } = getArrayFieldData(
      allItems,
      (item) => item.basicItem?.processSteps
    );

    return {
      title: "Systems per Process Step (Bar Chart)",
      categories: entries.map((entry) => entry.label),
      data: entries.map((entry) => entry.count),
      chartType: 1 as const,
      xLabel: "Systems",
      yLabel: "Process Step",
      colors: entries.map((entry) => entry.color),
      fixedHeight: "320px",
    };
  });

  const processStepsDonutChartComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "processStepsDashboardDonutChartComponent",
      labels: ["donutChart", "chart", "processStep"],
      description: "Shows systems grouped by process step across all projects.",
      title: "Systems per Process Step",
    },
  });

  processStepsDonutChartComponent.mapState(({ dashboard }) => {
    const allItems = getAllReportingItems(dashboard);
    const { entries } = getArrayFieldData(
      allItems,
      (item) => item.basicItem?.processSteps
    );

    return {
      title: withTotalInTitle("Systems per Process Step", allItems.length),
      icon: "DonutLarge",
      ...DONUT_CARD_LAYOUT,
      data: entries.map((entry) => ({
        label: entry.label,
        value: entry.count,
        color: entry.color,
      })),
    };
  });
}
